var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.2919L15.0222 3.11699C14.3825 2.03966 13.2526 1.39648 11.9997 1.39648C10.7467 1.39648 9.61682 2.03966 8.97829 3.11507L0.498116 17.2938C-0.893418 19.6375 0.79296 22.6036 3.52067 22.6036H20.4786C23.2026 22.6037 24.8951 19.6414 23.5 17.2919ZM20.4786 21.1976H3.52067C1.88201 21.1976 0.873726 19.4154 1.70599 18.0136L10.1862 3.83488C10.57 3.18843 11.2479 2.8025 11.9997 2.8025C12.7514 2.8025 13.4294 3.18843 13.8143 3.83675L22.2922 18.0116C23.1271 19.4178 22.1153 21.1976 20.4786 21.1976Z",
    fill: "#DA4655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 15.5732C10.8372 15.5732 9.89111 16.5194 9.89111 17.6823C9.89111 18.8453 10.8372 19.7914 12.0002 19.7914C13.1632 19.7914 14.1093 18.8453 14.1093 17.6823C14.1093 16.5194 13.1632 15.5732 12.0002 15.5732ZM12.0002 18.3854C11.6125 18.3854 11.2972 18.07 11.2972 17.6824C11.2972 17.2947 11.6125 16.9794 12.0002 16.9794C12.3879 16.9794 12.7032 17.2947 12.7032 17.6824C12.7032 18.07 12.3879 18.3854 12.0002 18.3854Z",
    fill: "#DA4655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 5.73047C10.8372 5.73047 9.89111 6.6766 9.89111 7.83957V12.0578C9.89111 13.2207 10.8372 14.1669 12.0002 14.1669C13.1632 14.1669 14.1093 13.2207 14.1093 12.0578V7.83957C14.1093 6.67664 13.1632 5.73047 12.0002 5.73047ZM12.7032 12.0578C12.7032 12.4455 12.3879 12.7608 12.0002 12.7608C11.6125 12.7608 11.2972 12.4455 11.2972 12.0578V7.83961C11.2972 7.45196 11.6125 7.13658 12.0002 7.13658C12.3879 7.13658 12.7032 7.45196 12.7032 7.83961V12.0578Z",
    fill: "#DA4655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0079330afb2e96928a9a8a8e426c8864.svg";
export { ForwardRef as ReactComponent };